const BigSmall1 = [
    {id: "0", value: "小於"},    
    {id: "1", value: "大於"},
    {id: "2", value: "等於"},    
  ];  
  
  export default BigSmall1  